/* eslint-disable no-param-reassign */
import { addToGlobalDataLayer } from '@ncl/modules/shared/globals/datalayer';

export function onCurrentUserChange(change, store) {
  const currentUser = change.newValue;
  addToGlobalDataLayer('CNPJ', currentUser.federalId);
  store.users = [{ email: currentUser.email }];
}
